/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-escape */
/* eslint-disable react-hooks/exhaustive-deps */
import '../../../activity.scss';
import './viewLinkedActivityForm.scss';
import '../../financialHelpText.scss';
import { SeeMore } from '../../../../../../components';
import { useSelector, useDispatch } from 'react-redux';
import { get, isEmpty, map } from '../../../../../../utils/lodash';
import { isGrantProgramActivity } from '../../../../../../utils/activity';
import { getPageDisable } from '../../../../../../utils';
import { useState } from 'react';
import { Grid, Button, Modal } from 'semantic-ui-react';
import {
  reInviteLinkActivity,
  putLinkedActivityProgramAmount,
} from '../../../../../../store/actions';
import thousands from 'thousands';
import { useTranslation } from 'react-i18next';

export default function ViewLinkedActivityForm(props) {
  const dispatch = useDispatch();
  const { activity, projected, toggle, currentState } = props;
  const { t } = useTranslation();

  const { currentActivity, linkedActivitiesActivateLoading } = useSelector(
    (state) => state.activity
  );
  const { user } = useSelector((state) => state.authentication);

  const [notifyModal, setNotifyModal] = useState(false);

  // TAK-2086: the program manager or a same-organisation collaborator can
  // change the amount here (the server checks this too)
  const isGrantProgram = get(currentActivity, 'activityPlanTypeId') === 4;
  const canEditProgramAmount =
    !projected &&
    !getPageDisable(currentActivity, user, currentState) &&
    (user.role === 'admin' ||
      get(currentActivity, 'owner.id') === user.id ||
      Number(user.organisationId) ===
        Number(get(currentActivity, 'owner.organisationId')));
  const [programAmounts, setProgramAmounts] = useState({
    projectedGrantAmount: activity.projectedGrantAmount,
    actualGrantAmount: activity.actualGrantAmount,
  });
  const [programAmountDraft, setProgramAmountDraft] = useState({});
  const saveProgramAmount = async (field) => {
    const typed = programAmountDraft[field];
    if (typed === undefined) {
      return;
    }
    const value = String(typed).replace(/,/g, '').trim();
    const amount = value === '' ? 0 : Number(value);
    if (!(amount >= 0)) {
      return;
    }
    const saved = await dispatch(
      putLinkedActivityProgramAmount(currentActivity.id, activity.id, {
        [field]: amount,
      })
    );
    if (saved) {
      setProgramAmounts({
        projectedGrantAmount: saved.projectedGrantAmount,
        actualGrantAmount: saved.actualGrantAmount,
      });
    }
    setProgramAmountDraft((draft) => ({ ...draft, [field]: undefined }));
  };
  const renderProgramAmountField = (field, labelKey, editable) => (
    <Grid.Column className="linked-activity-model-column">
      <label className="goal-label">{t(labelKey)}</label>
      <div>
        {editable ? (
          <input
            className="program-amount-input"
            inputMode="decimal"
            value={
              programAmountDraft[field] !== undefined
                ? programAmountDraft[field]
                : thousands(programAmounts[field]) || '0.00'
            }
            onFocus={() =>
              setProgramAmountDraft((draft) => ({
                ...draft,
                [field]: String(programAmounts[field] || ''),
              }))
            }
            onChange={(e) => {
              const typed = e.target.value;
              if (typed === '' || /^\d+\.?\d{0,2}$/.test(typed)) {
                setProgramAmountDraft((draft) => ({
                  ...draft,
                  [field]: typed,
                }));
              }
            }}
            onBlur={() => saveProgramAmount(field)}
          />
        ) : (
          <label className="evidence-modal-label">
            $ {thousands(programAmounts[field]) || '0.00'}
          </label>
        )}
      </div>
    </Grid.Column>
  );
  const projectedProgramAmountField = renderProgramAmountField(
    'projectedGrantAmount',
    isGrantProgram
      ? 'activity.activity_plan.activity_input.projected_program_grant'
      : 'activity.activity_plan.activity_input.projected_program_contribution',
    canEditProgramAmount
  );
  const actualProgramAmountField =
    activity.statusId !== 1
      ? renderProgramAmountField(
          'actualGrantAmount',
          isGrantProgram
            ? 'expenditure_status.actual_program_grant'
            : 'expenditure_status.actual_program_contribution',
          canEditProgramAmount
        )
      : null;

  const notifyUser = () => {
    dispatch(reInviteLinkActivity(activity.parentId, activity.id));
    setNotifyModal(false);
  };

  return (
    <div>
      {/* Notification modal */}
      <Modal
        open={notifyModal}
        closeIcon={
          <div
            className="new-activity-modal-close-icon"
            onClick={() => setNotifyModal(false)}
          >
            &times;
          </div>
        }
        size="tiny"
      >
        <Modal.Header className="notify-modal-header">
          {t('activity.linked_activity.notify_activity_manager')}
        </Modal.Header>
        <Modal.Content>
          <p>{t('activity.linked_activity.notify_activity_manager_confirm')}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button
            className="activity-activation-cancel-btn"
            onClick={() => setNotifyModal(false)}
          >
            {t('actions.no')}
          </Button>
          <Button
            loading={linkedActivitiesActivateLoading}
            disabled={linkedActivitiesActivateLoading}
            className="new-collective-save-btn"
            onClick={() => notifyUser()}
            content={t('actions.notify')}
          />
        </Modal.Actions>
      </Modal>
      {/* Goal */}
      <Grid className="mb-8">
        <Grid.Column className="linked-activity-model-column">
          <label className="goal-label">{t('common.goal')}</label>
          <div>
            <label className="evidence-modal-label">
              {get(currentActivity, 'goal')}
            </label>
          </div>
        </Grid.Column>
      </Grid>

      {/* Primary Domain & Secondary Domain */}
      <Grid className="mb-8">
        <Grid.Column
          className="linked-activity-model-column"
          mobile={16}
          tablet={8}
          computer={8}
        >
          <label className="goal-label">
            {t('activity.activity_plan.form.primary_domain')}
          </label>
          <div>
            {currentActivity.primaryPolicy && (
              <label className="evidence-modal-label">
                {currentActivity.primaryPolicy.policyName}
              </label>
            )}
          </div>
        </Grid.Column>
        {!isEmpty(currentActivity.parentDomains) && (
          <Grid.Column
            className="linked-activity-model-column"
            mobile={16}
            tablet={8}
            computer={8}
          >
            <label className="goal-label">
              {t('activity.activity_plan.form.secondary_domain')}
            </label>

            <ul className="linked-activity-model-margin-bottom">
              {map(currentActivity.parentDomains, (domain, i) => (
                <li key={i} className="evidence-modal-label">
                  {domain.policy.policyName}
                </li>
              ))}
            </ul>
          </Grid.Column>
        )}
        {!isEmpty(currentActivity.secondaryPolicy) && (
          <Grid.Column
            className="linked-activity-model-column"
            mobile={16}
            tablet={8}
            computer={8}
          >
            <label className="goal-label">
              {t('activity.activity_plan.form.secondary_domain')}
            </label>
            <div>
              <label className="evidence-modal-label">
                {currentActivity.secondaryPolicy.policyName}
              </label>
            </div>
          </Grid.Column>
        )}
      </Grid>

      {/* Primary Objective */}
      <Grid className="mb-8">
        {!isEmpty(activity.primaryParentObjectives) && (
          <Grid.Column
            className="linked-activity-model-column"
            mobile={16}
            tablet={8}
            computer={8}
          >
            <label className="goal-label">
              {t('activity.activity_plan.form.primary_objective')}
            </label>

            <ul className="custom-multiple-checkbox-ul">
              {activity.primaryParentObjectives.length < 4 ? (
                activity.primaryParentObjectives.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))
              ) : (
                <SeeMore
                  minCount={3}
                  dataSet={activity.primaryParentObjectives}
                  CustomComponent={(props) => <li>{props.item}</li>}
                  isView={false}
                />
              )}
            </ul>
          </Grid.Column>
        )}
      </Grid>

      {/* Secondary Objective */}
      <Grid className="mb-8">
        {!isEmpty(activity.secondaryParentObjectives) && (
          <Grid.Column
            className="linked-activity-model-column"
            mobile={16}
            tablet={8}
            computer={8}
          >
            <label className="goal-label">
              {t('activity.activity_plan.form.secondary_objective')}
            </label>

            <ul className="custom-multiple-checkbox-ul">
              {activity.secondaryParentObjectives.length < 4 ? (
                activity.secondaryParentObjectives.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))
              ) : (
                <SeeMore
                  minCount={3}
                  dataSet={activity.secondaryParentObjectives}
                  CustomComponent={(props) => <li>{props.item}</li>}
                  isView={false}
                />
              )}
            </ul>
          </Grid.Column>
        )}
      </Grid>

      {/* Activity Name */}
      <Grid className="mb-8">
        <Grid.Column className="linked-activity-model-column">
          <label className="goal-label">{t('common.activity_name')}</label>
          <div>
            <label className="evidence-modal-label">
              {get(activity, 'activityName')}
            </label>
          </div>
        </Grid.Column>
      </Grid>

      {/* Activity Notes */}
      <Grid className="mb-8">
        <Grid.Column className="linked-activity-model-column">
          <label className="goal-label">{t('common.activity_notes')}</label>
          <div>
            <label className="evidence-modal-label">
              {get(activity, 'activityNotes')}
            </label>
          </div>
        </Grid.Column>
      </Grid>

      {/* Grant ID */}
      {isGrantProgramActivity(currentActivity.activityPlanTypeId) && (
        <Grid className="mb-8">
          <Grid.Column className="linked-activity-model-column">
            <label className="goal-label">{t('formulary.grant_id')}</label>
            <div>
              <label className="evidence-modal-label">
                {get(activity, 'grantId')}
              </label>
            </div>
          </Grid.Column>
        </Grid>
      )}

      {/* First Name & Last Name */}
      <Grid className="mb-8">
        <Grid.Column
          className="linked-activity-model-column"
          mobile={16}
          tablet={8}
          computer={8}
        >
          <label className="goal-label">{t('formulary.first_name')}</label>
          <div>
            <label className="evidence-modal-label">
              {activity.owner.firstName}
            </label>
          </div>
        </Grid.Column>
        <Grid.Column
          className="linked-activity-model-column"
          mobile={16}
          tablet={8}
          computer={8}
        >
          <label className="goal-label">{t('formulary.last_name')}</label>
          <div>
            <label className="evidence-modal-label">
              {activity.owner.surname}
            </label>
          </div>
        </Grid.Column>
      </Grid>

      {/* Email & Phone */}
      <Grid className="mb-8">
        <Grid.Column
          className="linked-activity-model-column"
          mobile={16}
          tablet={8}
          computer={8}
        >
          <label className="goal-label">{t('formulary.email')}</label>
          <div>
            <label className="evidence-modal-label">
              {activity.owner.email}
            </label>
          </div>
        </Grid.Column>
        <Grid.Column
          className="linked-activity-model-column"
          mobile={16}
          tablet={8}
          computer={8}
        >
          <label className="goal-label">{t('formulary.phone')}</label>
          <div>
            <label className="evidence-modal-label">
              {activity.owner.phone}
            </label>
          </div>
        </Grid.Column>
      </Grid>

      {/* Business/ Organisation Name */}
      <Grid className="mb-8">
        <Grid.Column className="linked-activity-model-column">
          <label className="goal-label">
            {t('formulary.business_organisation_name')}
          </label>
          <div>
            <label className="evidence-modal-label">
              {activity.owner.organisationId
                ? get(activity, 'owner.organisation.name', '-')
                : get(activity, 'owner.entityName', '-')}
            </label>
          </div>
        </Grid.Column>
      </Grid>

      {/* Address Line 1 & Address Line 2 */}
      <Grid className="mb-8">
        {activity.owner.country && (
          <Grid.Column
            className="linked-activity-model-column"
            mobile={16}
            tablet={8}
            computer={8}
          >
            <label className="goal-label">{t('formulary.country')}</label>
            <div>
              <label className="evidence-modal-label">
                {activity.owner.country}
              </label>
            </div>
          </Grid.Column>
        )}
      </Grid>

      <Grid className="mb-8">
        {activity.owner.address1 && (
          <Grid.Column
            className="linked-activity-model-column"
            mobile={16}
            tablet={8}
            computer={8}
          >
            <label className="goal-label">
              {t('formulary.address_line_1')}
            </label>
            <div>
              <label className="evidence-modal-label">
                {activity.owner.address1}
              </label>
            </div>
          </Grid.Column>
        )}
        {activity.owner.address2 && (
          <Grid.Column
            className="linked-activity-model-column"
            mobile={16}
            tablet={8}
            computer={8}
          >
            <label className="goal-label">
              {t('formulary.address_line_2')}
            </label>
            <div>
              <label className="evidence-modal-label">
                {activity.owner.address2}
              </label>
            </div>
          </Grid.Column>
        )}
      </Grid>

      {/* Suburb & State & Post Code */}
      <Grid className="mb-8">
        {activity.owner.suburb && (
          <Grid.Column
            className="linked-activity-model-column"
            mobile={16}
            tablet={8}
            computer={5}
          >
            <label className="goal-label">{t('formulary.suburb')}</label>
            <div>
              <label className="evidence-modal-label">
                {activity.owner.suburb}
              </label>
            </div>
          </Grid.Column>
        )}
        {activity.owner.postcode && (
          <Grid.Column
            className="linked-activity-model-column"
            mobile={16}
            tablet={8}
            computer={5}
          >
            <label className="goal-label">{t('formulary.state')}</label>
            <div>
              <label className="evidence-modal-label">
                {activity.owner.state}
              </label>
            </div>
          </Grid.Column>
        )}
        {activity.owner.postcode && (
          <Grid.Column
            className="linked-activity-model-column"
            mobile={16}
            tablet={8}
            computer={5}
          >
            <label className="goal-label">{t('formulary.post_code')}</label>
            <div>
              <label className="evidence-modal-label">
                {activity.owner.postcode}
              </label>
            </div>
          </Grid.Column>
        )}
      </Grid>

      {/* TAK-2086: Program Contribution / Program Grant — projected, and
          actual once the linked activity is green lit */}
      <Grid className="mb-8" columns={2}>
        {projectedProgramAmountField}
        {actualProgramAmountField}
      </Grid>
      <div className="field-help-text">
        {t('activity.activity_plan.activity_input.program_amount_help')}
      </div>

      {/* Notify Activity Manager */}
      {!projected && activity ? (
        <Grid>
          <Grid.Column textAlign="right" verticalAlign="middle">
            <div className="activity-model-buttons">
              {activity.statusId !== 3 &&
              !activity.review &&
              !getPageDisable(currentActivity, user, currentState) ? (
                <Button
                  content={
                    activity.isNotified
                      ? t('activity.linked_activity.re_send_notification')
                      : t('activity.linked_activity.notify_activity_manager')
                  }
                  onClick={() => setNotifyModal(true)}
                  basic
                  color="orange"
                  className="activity-reinvite-button"
                />
              ) : null}
              <Button
                content={t('actions.close')}
                className="activity-confirm-button"
                onClick={() => toggle()}
              />
            </div>
          </Grid.Column>
        </Grid>
      ) : null}
    </div>
  );
}
